import React, { useEffect } from "react";
import CommonBanner from "../../components/CommonBanner/CommonBanner";
import "../TermsConditions/terms.scss";
import { termsUrl } from "../../helpers/paths";
const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CommonBanner
        link={termsUrl}
        text="Terms & Conditions"
        title="Terms & Conditions"
      />
      <section className="Terms_conditions_container my_container">
        <div className="wrapper_section_terms" data-aos="fade-up">
          <p className="privay_terms_Peragraph head_para">
            VISITORS TO THIS WEBSITE ARE BOUND BY THE FOLLOWING TERMS AND
            CONDITIONS ("TERMS") SO PLEASE READ THESE CAREFULLY BEFORE
            CONTINUING TO USE THIS SITE. IF YOU DO NOT AGREE WITH ANY OF THESE
            TERMS, PLEASE DO NOT USE THIS SITE. IF YOU HAVE ANY QUESTIONS ABOUT
            THESE TERMS, PLEASE CONTACT{" "}
            <a href="mailto:info@kapindra.com">info@kapindra.com</a>
          </p>
        </div>

        <div className="wrapper_section_terms" data-aos="fade-up">
          <p className="privay_terms_Peragraph head_para">
            <strong>
              Disclaimer of Warranties, Inaccuracies or Errors | Kapindra
              Disclaimer | Availability | Third Party Interaction and Links to
              Third Party Sites | Copyrights | Trademarks | General Terms and
              Conditions | Applicable Law and Jurisdiction |
            </strong>
          </p>
        </div>

        <div className="wrapper_section_terms" data-aos="fade-up">
          <div className="privay_terms_heading">
            Disclaimer of Warranties, Inaccuracies or Errors
          </div>
          <p className="privay_terms_Peragraph">
            1. Although Kapindra tries to ensure that all information and
            recommendations, whether in relation to the products, services,
            offerings or otherwise (hereinafter "Information") provided as part
            of this website is correct at the time of inclusion on the website,
            Kapindra does not guarantee the accuracy of the Information.
            Kapindra makes no representations or warranties as to the
            completeness or accuracy of Information.
          </p>
          <p className="privay_terms_Peragraph">
            2. Kapindra makes no commitment to update or correct any Information
            that appears on the Internet or on this website
          </p>
          <p className="privay_terms_Peragraph">
            3. Information is supplied upon the condition that the persons
            receiving the same will make their own determination as to its
            suitability for their purposes prior to use or in connection with
            the making of any decision. No Information at this website shall
            constitute an invitation to invest in Kapindra or any affiliates.
            Any use of this website or the Information is at your own risk.
            Neither Kapindra and Kapindra affiliates, nor their officers,
            employees or agents shall be liable for any loss, damage or expense
            arising out of any access to, use of, or Kapindra upon, this website
            or the Information, or any website linked to this website.
          </p>
          <p className="privay_terms_Peragraph">
            4. Nothing contained herein is to be construed as a recommendation
            to use any product, process, equipment, or formulation, in conflict
            with any patent, or otherwise and Kapindra makes no representation
            or warranty, express or implied that, the use thereof will not
            infringe any patent, or otherwise.
          </p>
          <p className="privay_terms_Peragraph">
            THIS WEBSITE IS PROVIDED TO YOU ON AN "AS IS" AND "WHERE-IS" BASIS,
            WITHOUT ANY WARRANTY. KAPINDRA, FOR ITSELF AND ANY THIRD PARTY
            PROVIDING MATERIALS, SERVICES, OR CONTENT TO THIS WEBSITE, MAKES NO
            REPRESENTATIONS OR WARRANTIES, EITHER EXPRESS, IMPLIED, STATUTORY OR
            OTHERWISE OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
            NONINFRINGEMENT OF THIRD PARTY RIGHTS, WITH RESPECT TO THE WEBSITE,
            THE INFORMATION OR ANY PRODUCTS OR SERVICES TO WHICH THE INFORMATION
            REFERS. KAPINDRA WILL NOT BE LIABLE TO YOU OR ANY THIRD PARTY FOR
            ANY DAMAGES OF ANY KIND, INCLUDING BUT NOT LIMITED TO, DIRECT,
            INDIRECT, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, ARISING
            FROM OR CONNECTED WITH THE SITE, INCLUDING BUT NOT LIMITED TO, YOUR
            USE OF THIS SITE OR YOUR INABILITY TO USE THE SITE, EVEN IF KAPINDRA
            HAS PREVIOUSLY BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </p>
        </div>

        <div className="wrapper_section_terms" data-aos="fade-up">
          <div className="privay_terms_heading">Kapindra Disclaimer</div>
          <p className="privay_terms_Peragraph">
            Kapindra companies have their own separate identities but in this
            website we may sometimes use "Kapindra", "Group", "we" or "us" when
            we refer to Kapindra companies in general or where no useful purpose
            is served by identifying any particular Kapindra company.
          </p>
        </div>

        <div className="wrapper_section_terms" data-aos="fade-up">
          <div className="privay_terms_heading">Availability</div>
          <p className="privay_terms_Peragraph">
            1. Kapindra controls and operates this website from India and makes
            no representation that the materials are appropriate or will be
            available for use in other locations. If you use this website from
            outside the India, you are entirely responsible for compliance with
            all applicable local laws.
          </p>
          <p className="privay_terms_Peragraph">
            2. Kapindra has several websites offering products, services,
            content and various other functionalities (collectively the
            "Services") to specific regions worldwide. The Services offered in
            one region may differ from those in other regions due to
            availability, local or regional laws, shipment and other
            considerations. Kapindra does not make any warranty or
            representation that a user in one region may obtain the Services
            from the Kapindra site in another region and Kapindra may cancel a
            user's order or redirect a user to the site for that user's region
            if a user attempts to order Services offered on a site in another
            region.
          </p>
          <p className="privay_terms_Peragraph">
            3. Information that Kapindra publishes on the World Wide Web may
            contain references or cross references to Kapindra products,
            programs and services that are not announced or available in your
            country. Such references do not imply that Kapindra intends to
            announce such products, programs or services in your country.
            Consult your local Kapindra business contact for information
            regarding the products, programs and services that may be available
            to you.
          </p>
        </div>

        <div className="wrapper_section_terms" data-aos="fade-up">
          <div className="privay_terms_heading">
            Third Party Interaction and Links to Third Party Sites
          </div>
          <p className="privay_terms_Peragraph">
            1. In your use of the website, you may enter into correspondence
            with, purchase goods and/or services from, or participate in
            promotions of advertisers or sponsors of the website. Unless
            otherwise stated, any such correspondence, advertisement, purchase
            or promotion, including the delivery of and the payment for goods
            and/or services, and any other term, condition, warranty or
            representation associated with such correspondence, purchase or
            promotion, is solely between you and the applicable third party. You
            agree that Kapindra has no liability, obligation or responsibility
            for any such correspondence, purchase or promotion between you and
            any such third party.
          </p>
          <p className="privay_terms_Peragraph">
            2. This website may be linked to other websites on the World Wide
            Web that are not under the control of or maintained by Kapindra.
            Such links do not indicate any responsibility or endorsement on our
            part for the external website concerned, its contents or the links
            displayed on it. These links are provided only as a convenience, in
            order to help you find relevant websites, services and/or products
            that may be of interest to you, quickly and easily. It is your
            responsibility to decide whether any services and/or products
            available through any of these websites are suitable for your
            purposes. Kapindra is not responsible for the owners or operators of
            these websites or for any goods or services they supply or for the
            content of their websites and does not give or enter into any
            conditions, warranties or other terms or representations in relation
            to any of these or accept any liability in relation to any of these
            (including any liability arising out of any claim that the content
            of any external website to which this website includes a link
            infringes the intellectual property rights of any third party).
          </p>
        </div>

        <div className="wrapper_section_terms" data-aos="fade-up">
          <div className="privay_terms_heading">Copyrights</div>
          <p className="privay_terms_Peragraph">
            1. This website contains material, including text, graphics and
            sound, which is protected by copyright and/or other intellectual
            property rights. All copyright and other intellectual property
            rights in this material are either owned by Kapindra or have been
            licensed to Kapindra by the owner(s) of those rights so that it can
            use this material as part of this website. Kapindra retains
            copyright on all Information, including text, graphics and sound and
            all trademarks displayed on this website are owned by Kapindra or
            used under licence by Kapindra affiliates.
          </p>
          <p className="privay_terms_Peragraph">2. You may:</p>
          <p className="privay_terms_Peragraph">
            use and display the materials only on your personal computer only
            for personal use. Kapindra grants you a limited, personal,
            non-exclusive and non-transferable license only for such use.
          </p>
          <p className="privay_terms_Peragraph">
            print copies of the information on this site for your personal use
            and store the files on your computer for personal use.
          </p>
          <p className="privay_terms_Peragraph">3. You may not:</p>
          <p className="privay_terms_Peragraph">
            copy (whether by printing off onto paper, storing on disk,
            downloading or in any other way), distribute (including distributing
            copies), download, display, perform, reproduce, distribute, modify,
            edit, alter, enhance, broadcast or tamper with in any way or
            otherwise use any material contained in the website except as set
            out under "You may". These restrictions apply in relation to all or
            part of the material on the website;
          </p>
          <p className="privay_terms_Peragraph">
            copy and distribute this information on any other server, or modify
            or re-use text or graphics on this system or another system. No
            reproduction of any part of the website may be sold or distributed
            for commercial gain nor shall it be modified or incorporated in any
            other work, publication or website, whether in hard copy or
            electronic format, including postings to any other website.
          </p>
          <p className="privay_terms_Peragraph">
            remove any copyright, trade mark or other intellectual property
            notices contained in the original material from any material copied
            or printed off from the website; link to this website; without our
            express written consent.
          </p>
        </div>

        <div className="wrapper_section_terms" data-aos="fade-up">
          <div className="privay_terms_heading">Trademarks</div>
          <p className="privay_terms_Peragraph">
            The Kapindra™ and all products and logos denoted with TM or ? are
            trademarks or registered trademarks of Kapindra or its affiliates.
            Kapindra trademarks may not be used in connection with any product
            or service that is not a Kapindra product or service.
          </p>
        </div>

        <div className="wrapper_section_terms" data-aos="fade-up">
          <div className="privay_terms_heading">
            General Terms and Conditions
          </div>
          <p className="privay_terms_Peragraph">
            1. Kapindra does not routinely monitor your postings to the website
            but reserves the right to do so. However, in our efforts to promote
            good citizenship within the Internet community, if Kapindra becomes
            aware of inappropriate use of the website or any of its Services,
            Kapindra will respond in any way that, in its sole discretion,
            Kapindra deems appropriate. You acknowledge that Kapindra will have
            the right to report to law enforcement authorities any actions that
            may be considered illegal, as well as any information it receives of
            such illegal conduct. When requested, Kapindra will co-operate fully
            with law enforcement agencies in any investigation of alleged
            illegal activity on the Internet.
          </p>
          <p className="privay_terms_Peragraph">
            2. Unauthorised use of any materials contained on this website may
            violate copyright laws, trademark laws, the laws of privacy and
            publicity, certain communications statutes and regulations and other
            applicable laws and regulations. You alone are responsible for your
            actions or the actions of any person using your user name and/or
            password. As such, you shall indemnify and hold Kapindra and its
            officers, directors, employees, affiliates, agents, licensors, and
            business partners harmless from and against any and all loss, costs,
            damages, liabilities, and expenses (including attorneys' fees)
            incurred in relation to, arising from, or for the purpose of
            avoiding, any claim or demand from a third party that your use of
            the website or the use of the website by any person using your user
            name and/or password (including without limitation your
            participation in the posting areas) violates any applicable law or
            regulation, or the rights of any third party.
          </p>
          <p className="privay_terms_Peragraph">
            3. Kapindra reserves the right to terminate access to this website
            at any time and without notice. Further this limited license
            terminates automatically, without notice to you, if you breach any
            of these Terms. Upon termination, you must immediately destroy any
            downloaded and printed materials.
          </p>
          <p className="privay_terms_Peragraph">
            4. Kapindra may change the terms and conditions and disclaimer set
            out above from time to time. By browsing this website you are
            accepting that you are bound by the current terms and conditions and
            disclaimer and so you should check these each time you revisit the
            website.
          </p>
          <p className="privay_terms_Peragraph">
            5. Kapindra may change the format and content of this website at any
            time.
          </p>
          <p className="privay_terms_Peragraph">
            6. Kapindra may suspend the operation of this website for support or
            maintenance work, in order to update the content or for any other
            reason.
          </p>
          <p className="privay_terms_Peragraph">
            7. Personal details provided to Kapindra through this website will
            only be used in accordance with our privacy policy. Please read this
            carefully before going on. By providing your personal details to us
            you are consenting to its use in accordance with our privacy policy.
          </p>
          <p className="privay_terms_Peragraph">
            8. If you have a question or complaint, please contact us at{" "}
            <a href="mailto:info@kapindra.com">info@kapindra.com</a>
          </p>
          <p className="privay_terms_Peragraph">
            9. Kapindra reserves all other rights
          </p>
        </div>

        <div className="wrapper_section_terms" data-aos="fade-up">
          <div className="privay_terms_heading">
            Applicable Law and Jurisdiction
          </div>
          <p className="privay_terms_Peragraph">
            These terms and conditions are governed by and to be interpreted in
            accordance with laws of India, without regard to the choice or
            conflicts of law provisions of any jurisdiction. You agree, in the
            event of any dispute arising in relation to these terms and
            conditions or any dispute arising in relation to the website whether
            in contract or tort or otherwise, to submit to the exclusive
            jurisdiction of the courts located at Mumbai, India for the
            resolution of all such disputes.
          </p>
        </div>
      </section>
    </>
  );
};

export default Terms;
